<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0H16V11.9981H0V0Z" fill="#C8102E" />
    <path d="M5.1416 0H6.85633V11.9981H5.1416V0Z" fill="white" />
    <path d="M0 5.1417H16V6.85643H0V5.1417Z" fill="white" />
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
